import "./Loader.css";

export function Loader() {
    return <div style={{ position: 'fixed', top: '45%', left: '56%', transform: 'translate(-50%, -50%)'}}><span className="loader"></span></div>;
}

